module.exports = __webpack_public_path__ + "img/ورزشی.e4c4df81.jpg";